import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getUsefulInfo = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const response = await api('get', 'useful-info/', data);
        return response.data || {};
    });
